import {Row, Col, Card, Table, Button, Input, Tooltip, Image, Switch, Select, Modal, Skeleton} from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import ShowTotal from "../../components/ShowTotal";
import ConfirmationBox from "../../components/ConfirmationBox";
import apiPath from "../../constants/apiPath";
import moment from 'moment';
import { formatDate } from "../../helper/DateHelper";
import notfound from "../../assets/images/not_found.png";
import { CloseOutlined, CheckOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import From from "./From";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { getSortOrder } from "../../constants/conts";
import "../../assets/styles/popularBrands.css";
const Search = Input.Search;
const { Option } = Select;
function Index() {

  const sectionName   =   "Brand";
  const routeName     =   "brand";

  const api = {
    status          :   apiPath.statusBrand,
    verify          :   apiPath.verifyBrand,
    addEdit         :   apiPath.addEditBrand,
    list            :   apiPath.listBrand,
    brandPopularity :   apiPath.commonBrandPopularity,
  }
  
  const location        =   useLocation();
  const navigate        =   useNavigate();
  
  const query           =   new URLSearchParams(location.search);
  const initialPage     =   parseInt(query.get("page")) || 1;
  const initialPageSize =   parseInt(query.get("pageSize")) || 20;
  const initialSearch   =   query.get("search") || "";
  const initialCity     =   query.get("city") || undefined;
  const initialSort     =   query.get("sort") || "";

  const [pagination, setPagination] = useState({
    current: initialPage,
    pageSize: initialPageSize,
  });
  
  const [searchText, setSearchText]   =   useState(initialSearch);
  const [cityId, setCityId]           =   useState(initialCity);
  const [sortBy, setSortBy]           =   useState(initialSort);

  const { request }                   =   useRequest()
  const [list, setList]               =   useState([])
  const { showConfirm }               =   ConfirmationBox()
  const [loading, setLoading]         =   useState(false)
  const [refresh, setRefresh]         =   useState(false)
  const [filters, setFilters]         =   useState({});
  const debouncedSearchText           =   useDebounce(searchText, 500);
  const [visible, setVisible]         =   useState(false);
  const [selected, setSelected]       =   useState();
  const [cityList, setCityList]       =   useState([]);
  const [citySearch, setCitySearch]   =   useState('');
  const [confirmingVerifyId, setConfirmingVerifyId] = useState(null);

  const [popularBrandsVisible, setPopularBrandsVisible] = useState(false);
  const [popularBrands, setPopularBrands]               = useState([]);
  const [popularBrandsLoading, setPopularBrandsLoading] = useState(false);

  const columns = [
    {
      title: "Logo",
      dataIndex: "logo",
      key: "logo",
      render: (_, { logo }) => <Image width={60} height={60} src={logo ? logo : notfound} />
    },
    {
      title: "BIN",
      dataIndex: "sp_code",
      key: "sp_code",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "sp_code"),
      render: (_, { sp_code }) => sp_code ? <span className="cap">{sp_code}</span> : '-',
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "name"),
      render: (_, { name }) => name ? <span className="cap">{name}</span> : '-',
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "category"),
      render: (_, { category }) =>
        category?.name ? <span className="cap">{category.name}</span> : '-',
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      render: (_, { city, city_selection }) => {
        if (city_selection === 'Single City') {
          return city && city.name ? <span className="cap">{city.name}</span> : '-';
        } else if (city_selection) {
          return city_selection;
        } else {
          return '-';
        }
      },
    },
    /* {
      title: "Cluster",
      dataIndex: "cluster",
      key: "cluster",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "cluster"),
      render: (_, { cluster }) => {
        return (
          cluster && cluster.name ? <span className="cap">{cluster.name}</span> : '-'
        );
      },
    }, */
    {
      title: "Status",
      key: "is_active",
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'Inactive',
          value: false,
        },
      ],
      render: (_, { is_active, _id }) => {
        return (
          <Switch
            checked = {is_active}
            checkedChildren = {<CheckOutlined />}
            unCheckedChildren = {<CloseOutlined />}
            loading = {loading}
            onChange = {(checked) =>
              showConfirm({
                record    : _id,
                path      : api.status,
                onLoading : () => setLoading(true),
                onSuccess : () => setRefresh((prev) => !prev),
                is_active : checked,
              })
            }
            className={is_active ? "custom-switch-checked" : ""}
          />
        );
      },
    },
    {
      title: "Verified",
      key: "is_verify",
      filters: [
        { text: "Verified", value: true },
        { text: "Not Verified", value: false },
      ],
      render: (_, { is_verify, _id }) => {
        const handleVerifyClick = (willBeChecked, e) => {
         
          e.preventDefault();

          if (confirmingVerifyId === _id) return;

          setConfirmingVerifyId(_id);

          Modal.confirm({
            // title: willBeChecked ? "Verify Brand" : "Unverify Brand",
            icon: <ExclamationCircleOutlined style={{ color: "#fa2f14" }} />,
            content: (
              <p style={{ textAlign: "center", fontSize: "1rem", fontWeight: "600" }}>
                {willBeChecked
                  ? "Are you sure you want to verify this brand?"
                  : "Are you sure you want to unverify this brand?"}
              </p>
            ),
            okText: willBeChecked ? "Verify" : "Unverify",
            cancelText: "No",
            centered: true,
            maskClosable: false,
            width: 400,
            onOk: () => {
              setConfirmingVerifyId(null);
              showConfirm({
                record: _id,
                path: api.verify,
                onLoading: () => setLoading(true),
                onSuccess: () => setRefresh((prev) => !prev),
                is_verify: willBeChecked,
              });
            },
            onCancel: () => {
              setConfirmingVerifyId(null);
            },
          });
        };

        return (
          <Switch
            checked={is_verify}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            loading={loading || confirmingVerifyId === _id}
            onClick={handleVerifyClick}
            className={is_verify ? "custom-switch-checked" : ""}
            disabled={confirmingVerifyId === _id}
          />
        );
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      sorter: true,
      sortOrder: getSortOrder(sortBy, "created_at"),
      render: (_, { created_at }) => {
        return (
          formatDate(created_at)
        );
      },
    },
    {
      title: "Action",
      fixed: 'right',
      render: (_, record) => {
        return (
          <>

            <Tooltip title={"Update " + sectionName} color={"purple"} key={"update"}>
              <Button onClick={() => { edit(record._id) }}>
                <i className="fa fa-light fa-pen"></i>
              </Button>
            </Tooltip>

            <Tooltip title={"View " + sectionName} color={"purple"} key={"view"}>
              <Button onClick={() => { view(record._id) }}>
                <i className="fa fa-light fa-eye"></i>
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];
  
  const view = (id) => {
    navigate(`/${routeName}/view/${id}${location.search}`);
  };

  const edit = (id) => {
    navigate(`/${routeName}/update/${id}${location.search}`);
  };

  useEffect(() => {
    const params = new URLSearchParams();

    if (pagination.current > 1) params.set("page", pagination.current);
    if (pagination.pageSize !== 20) params.set("pageSize", pagination.pageSize);
    if (debouncedSearchText) params.set("search", debouncedSearchText);
    if (cityId) params.set("city", cityId);
    if (sortBy) params.set("sort", sortBy);

    navigate({ search: params.toString() }, { replace: true });
  }, [pagination.current, pagination.pageSize, debouncedSearchText, cityId, sortBy, navigate]);
  
  // Fetch all the brand data
  const fetchData = (pagination, filters, sortValue = '') => {
    const filterActive = filters ? filters.is_active : null
    const filterVerify = filters ? filters.is_verify : null
    request({
      url:
        api.list +
        `?status=${filterActive ? filterActive.join(',') : ''}` +
        `&verify=${filterVerify ? filterVerify.join(',') : ''}` +
        `&page=${pagination.current}` +
        `&limit=${pagination.pageSize}` +
        `&search=${debouncedSearchText}` +
        `&sort=${sortValue || ''}` +
        `&city_id=${cityId || ''}`,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false)
        setList(data.data.list.docs)
        setPagination(prev => ({
          ...prev,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: data.data.list.totalDocs
        }));
      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const handleChange = (pag, newFilters, sorter) => {
    const { order, field } = sorter || {};

    let nextSort = '';
    if (order) {
      nextSort = `${field}:${order === 'ascend' ? 'asc' : 'desc'}`;
    }

    setFilters(newFilters || {});

    setSortBy(nextSort);

    setPagination(prev => ({
      ...prev,
      current: pag?.current || 1,
      pageSize: pag?.pageSize || prev.pageSize,
    }));
  };

  const onSearch = (e) => {
    setSearchText(e.target.value)
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  const fetchCitites = () => {
    request({
      url: `${apiPath.commonCity}`,
      method: 'GET',
      onSuccess: (res) => {
        const items = res?.data?.data || [];
        setCityList(items);
      },
      onError: (err) => {
        console.log(err);
      }
    });
  };

  const onRefresh = () => {
    setSearchText('');
    setCityId(undefined);
    setSortBy("");
    setPagination({ current: 1, pageSize: 20 });
    navigate({ search: "" }, { replace: true });
    setRefresh(prev => !prev);
  };

  const handleCityChange = (value) => {
    setCityId(value);
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    setLoading(true)
    fetchData(pagination, filters, sortBy)
  }, [refresh, debouncedSearchText, cityId, sortBy, pagination.current, pagination.pageSize, filters])

  useEffect(() => {
    fetchCitites()
  }, [])

  const fetchPopularBrands = () => {
    setPopularBrandsLoading(true);
    request({
      url: api.brandPopularity,
      method: 'GET',
      onSuccess: (response) => {
        setPopularBrands(response?.data?.data || []);
        setPopularBrandsLoading(false);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
        setPopularBrandsLoading(false);
      }
    });
  };

  const handleOpenPopularBrands = () => {
    setPopularBrandsVisible(true);
    fetchPopularBrands();
  };

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + " Management"}
              extra={
                <>
                  <Search
                    allowClear
                    size="large"
                    onChange={onSearch}
                    value={searchText}
                    onPressEnter={onSearch}
                    placeholder="Search By Name, Category, Cluster"
                    style={{ minWidth: 280 }}
                  />

                  <Button title="Popular Brands" onClick={handleOpenPopularBrands}><i className="fas fa-star"></i>&nbsp;&nbsp;Popular Brands</Button>
                  <Link className="ant-btn ant-btn-default" to={`/${routeName}/add${location.search}`}>Add New {sectionName}</Link>
                  <Link className="ant-btn ant-btn-default" to={`/${routeName}/suggestion`}>Suggested {sectionName}</Link>
                </>
              }
            >

              <div className="w-100 mb-3">
                <label className="form-label fw-semibold mb-2">Filter by City : </label>
                <Select
                  showSearch
                  allowClear
                  value={cityId}
                  onChange={handleCityChange}
                  placeholder="Select City"
                  optionFilterProp="children"
                  style={{ width: "20%" }}
                  className="shadow-sm rounded"
                  searchValue={citySearch}
                  onSearch={(val) => setCitySearch(val)}
                  onInputKeyDown={(e) => {
                    if (e.key === 'Backspace' && !citySearch) {
                      handleCityChange(undefined);
                    }
                  }}
                  filterOption={(input, option) =>
                    option?.children?.props?.children
                      ?.toLowerCase()
                      ?.includes(input?.toLowerCase())
                  }
                >
                  <Option key="default" value={null}> ---- Select ---- </Option>

                  {cityList?.map((item, index) => (
                    <Option key={index} value={item._id}>
                      <span className="cap">{item.name}</span>
                    </Option>
                  ))}
                </Select>

                <Button onClick={onRefresh} className="btn btn-primary ml-5 d-inline-flex align-items-center">
                  <i className="fa fa-refresh mr-5"></i> Clear Filter & Search
                </Button>
              </div>
              
              <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
              <div className="table-responsive customPagination">
                <Table
                  rowKey={(record) => record._id}
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    responsive: true,
                    defaultPageSize: 20,
                    pageSizeOptions: ['10', '20', '30', '50', '100']
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>

            </Card>
          </Col>
        </Row>
      </div>

      {visible &&
        <From
          path={api.addEdit}
          sectionName={sectionName}
          show={visible}
          hide={() => { setSelected(); setVisible(false) }}
          data={selected}
          refresh={() => setRefresh(prev => !prev)}
        />
      }

      <Modal
        title="Top 20 Popular Brands"
        open={popularBrandsVisible}
        onCancel={() => setPopularBrandsVisible(false)}
        footer={[
          <Button key="close" onClick={() => setPopularBrandsVisible(false)}>
            Close
          </Button>
        ]}
        centered
        width={600}
      >
        {popularBrandsLoading ? (
          <Skeleton active paragraph={{ rows: 5 }} />
        ) : popularBrands && popularBrands.length > 0 ? (
          <div className="popular-brands-container">
            <Row gutter={[16, 16]}>
              {popularBrands.map((brand, index) => (
                <Col span={24} xs={24} md={24} key={brand._id}>
                  <div className="brand-item">
                    <div className="brand-rank">#{index + 1}</div>
                    <div className="brand-info">
                      <h5 className="brand-name">{brand.name}</h5>
                      <p className="brand-popularity">Popularity Score: <strong>{brand.popularity || 0}</strong></p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        ) : (
          <div className="no-brands-message">
            <p>No popular brands available</p>
          </div>
        )}
      </Modal>
    </>
  );
}

export default Index;